import React, {FC, useEffect, useState} from "react"
import classNames from "classnames/bind";
import styles from 'ui/CustomPhone/Phone.module.scss';

const cn = classNames.bind(styles);

interface IPhoneMaskPlaceholder {
    value: string
    mask: string
}

const Mask:FC<IPhoneMaskPlaceholder> = ({mask, value}): React.ReactElement => {
    const [visibleMask, setVisibleMask] = useState<string>('')

    useEffect(() => {
        setVisibleMask(mask.substr(value ? value.length : 0))
    }, [value, mask])

    return <div className={cn('select__mask')}>
        <span className={cn('hide')}>{value}</span>
        <span className={cn('visible')}>{visibleMask}</span>
    </div>
}

export default React.memo(Mask)
